import _ from 'underscore';
import Backbone from 'backbone';
import tpl from './pmbonus-template.hbs';
import { eventBus } from '../state-manager/event-bus';
import { toShort, toText } from '../utils/number-format';

export var PmangBonusView = Backbone.View.extend({
  tagName: 'div',

  template: tpl,

  initialize: function () {
    this.model.on('sync', this.render, this);
    this.model.fetch();
    this.eventBus = eventBus;
  },

  events: {
    'click [data-pmbonus-switch-tab]': 'switchTab',
    'click [data-pmbonus-click=close]': 'close',
    'click [data-pmbonus-click=getReward]': 'getReward',
    'click [data-pmbonus-reward-id]': 'chooseReward'
  },

  switchTab: function (e) {
    e.preventDefault();
    var $target = this.$(e.currentTarget);
    this.$('[data-pmbonus-tab]')
      .removeClass('pmbonus-tab-benefit pmbonus-tab-usage')
      .addClass('pmbonus-tab-' + $target.data('pmbonus-switch-tab'));
  },

  render: function () {
    var isSuccess = this.model.get('isSuccess');
    var rendered = this.template(this.model.toJSON());
    var item;
    var totalMoneyText;
    var period = '';

    this.$el.html(rendered);

    // 보상 받기 성공
    if (isSuccess === true) {
      item = this.model.getItemById(this.model.get('rewardId'));
      totalMoneyText = toText(toShort(this.model.get('totalMoney')));
      period = item.validDate ? item.validDate.replace(/(\d\d\d\d)(\d\d)(\d\d)/, '$1/$2/$3') : '';

      this.eventBus.trigger('app:refresh');
      this.eventBus.trigger('show:message', {
        title: '피망 보너스 혜택 받기',
        // 혜택과 골드 나눠서 메시지 표시
        // 기획과 논의 후, 당분간은 딜러비 할인혜택 외에 추가 진행 예정이 없어서
        // 메시지를 하드코딩하기로 함
        message: item.rewardText
          ? [
              '<b>피망 보너스 혜택 :</b> <strong class="orange">' + item.reward + '</strong>',
              '<strong class="blue small">' +
                period +
                ' 까지 딜러비가 2.5% 추가 할인됩니다.</strong>'
            ]
          : [
              '<b>피망 보너스 혜택 :</b> <strong class="orange">' + item.reward + ' 골드</strong>',
              '<strong class="blue small">총합이 ' + totalMoneyText + ' 골드가 되었습니다.</strong>'
            ],
        onConfirm: _.bind(function () {
          // 결과 정보 리셋
          this.model.set({
            resultCode: null,
            isSuccess: null,
            rewardId: 0,
            rewardPoint: 0,
            chosenRewardId: null
          });
        }, this)
      });
    }

    if (isSuccess === false) {
      this.eventBus.trigger('show:message', {
        title: '피망 보너스 혜택 받기',
        message: ['죄송합니다. 피망 보너스 혜택을 받으실 수 없습니다', '잠시 후 다시 시도해주세요.']
      });
    }

    return this;
  },

  close: function (e) {
    e.preventDefault();
    this.model.set(this.model.defaults);
    this.remove();
  },

  chooseReward: function (e) {
    var $radio = $(e.currentTarget);

    if ($radio.is('.disabled') || $radio.is('.checked')) {
      return;
    }

    this.model.set('chosenRewardId', $radio.data('pmbonusRewardId'));
    this.$el.find('label.checked').removeClass('checked');
    $radio.addClass('checked');
  },

  getReward: function (e) {
    e.preventDefault();

    var item;
    var chosen = this.model.get('chosenRewardId');

    if (!chosen) {
      this.eventBus.trigger('show:message', {
        title: '피망 보너스 혜택 받기',
        message: '받으실 혜택을 선택 해주세요.'
      });
      return;
    }

    item = this.model.getItemById(chosen);

    this.eventBus.trigger('show:message', {
      title: '피망 보너스 혜택 받기',
      message: item.rewardText
        ? [
            '피망 보너스 <strong class="blue">' + item.pointText + '점</strong>을 사용하여',
            '<strong class="orange">' + item.reward + '</strong>',
            '혜택을 받으시겠습니까?',
            '<span class="small">' + item.periodWarning + '</span>'
          ]
        : [
            '피망 보너스 <strong class="orange">' + item.pointText + '점</strong>을 사용하여',
            '<strong class="blue">' + item.reward + ' 골드</strong>를 받으시겠습니까?'
          ],
      options: {
        onConfirm: _.bind(function () {
          this.model.save(
            { rewardId: this.model.get('chosenRewardId'), rewardPoint: item.point },
            { patch: true }
          );
        }, this),
        onCancel: _.noop
      }
    });
  }
});
